import { Component, OnInit, SimpleChanges, OnChanges, Output, Input, EventEmitter, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { UtilitiesService } from '../../../../services/utilities.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'receipt-commodity',
  templateUrl: './commodity.component.html',
  styleUrls: ['./commodity.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class CommodityComponent implements OnInit, OnChanges {


  @Input() enableChange;
  @Input() currenceis;
  @Input() label: string;
  @Input() isDutiable: boolean = false;
  @Input("ddlContent") ddlContent: any;
  tempContent = [];
  @Output() comedityObject = new EventEmitter();
  @Input() changing: boolean;
  showDdl: boolean;
  isOpen: boolean = true;
  searchTerm: string = "";
  selectedValue: any = {};
  goodsValue: string;
  otherCommodity: boolean = false;
  notIsCommodity: boolean = true;
  otherCommodityTxt: string = '';
  validOtherText: boolean = true;
  showCommodityList: boolean = true;
  selectedCommodity: any;
  branchCurrencyCode: string = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
  @Output() isEnableSelectShipmentItems = new EventEmitter();
  arrowkeyLocation

  ngOnChanges(changes: SimpleChanges) {
    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true) {
        this.isOpen = true;
        this.goodsValue = '';
        this.searchTerm = '';
        this.otherCommodity = false;
        this.otherCommodityTxt = '';
        this.branchCurrencyCode = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;
      }
    }
  }
  constructor(
    private utilites: UtilitiesService,
    private translate: TranslateService
    ) {
    this.arrowkeyLocation = 0;
  }

  selectCommodityDDL(ddlName) {
    this.selectedCommodity = ddlName;
    this.validatorObject['selectedCommodity'] = { valid: true, message: '' };
    this.selectedValue = ddlName;
    this.searchTerm = ddlName.key;
    // 14 means other (to specify commodity type)
    if (this.selectedValue.value == 14) {
      this.notIsCommodity = true;
      this.otherCommodity = true;
      this.isOpen = true;
      this.showCommodityList = false;
    }
    else {
      this.otherCommodity = false;
      this.showCommodityList = false;
    }
  }
  validatorObject = {
    goodsValue: {
      valid: false,
      message: '',
    },
    selectedCommodity: {
      valid: false,
      message: '',
    }
  }
  checkRequiredField() {
    if (this.goodsValue.trim() == '' || this.goodsValue.trim() == null || this.goodsValue.trim() == '0' || this.goodsValue.trim() == undefined) {
      if (this.isDutiable == true)
        this.validatorObject['goodsValue'] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.commodityPage.goodsReqMsg')}` };
      else
        this.validatorObject['goodsValue'] = { valid: true, message: '' };
    }
    else {
      const pattern = /^0|[1-9]\d*$/;
      if (pattern.test(this.goodsValue.trim())) {
        this.goodsValue = this.goodsValue.trim();
        this.validatorObject['goodsValue'] = { valid: true, message: '' };
      }
      else {
        this.goodsValue = this.goodsValue.trim();
        this.validatorObject['goodsValue'] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.commodityPage.invalidValueMsg')}` };
      }
    }
    if (this.selectedCommodity == '' || this.selectedCommodity == null || this.goodsValue == undefined && this.isDutiable == true) {
      if (this.isDutiable == true) {
        this.validatorObject['selectedCommodity'] = { valid: false, message: `<i class="unvalid armx - icon armx-cancel"></i> ${this.translate.instant('pages.createReceiptPage.commodityPage.selectCommodity')}` };
      }
      else {
        this.validatorObject['selectedCommodity'] = { valid: true, message: '' };
      }
    }
    else
      this.validatorObject['selectedCommodity'] = { valid: true, message: '' };
  }
  checkOtherComText() {
    this.validOtherText = this.otherCommodityTxt != '';
  }
  nextCommodity() {
    this.checkRequiredField();
    //this.checkRequiredField('selectedCommodity');
    if (this.validatorObject['goodsValue'].valid && this.validatorObject['selectedCommodity'].valid) {
      if (this.selectedCommodity.value != 14) {
        this.comedityObject.emit({ selectedCommodity: this.selectedCommodity, goodsValue: this.goodsValue, description: this.otherCommodityTxt, branchCurrencyCode: this.branchCurrencyCode });
        this.isOpen = !this.isOpen;
        this.isEnableSelectShipmentItems.emit(true);
      }
      else if (this.selectedCommodity.value == 14) {
        if (this.otherCommodityTxt != '') {
          this.validOtherText = true;
          this.comedityObject.emit({ selectedCommodity: this.selectedCommodity, goodsValue: this.goodsValue, description: this.otherCommodityTxt, branchCurrencyCode: this.branchCurrencyCode });
          this.isOpen = !this.isOpen;
          this.isEnableSelectShipmentItems.emit(true);
        }
        else {
          this.validOtherText = false;
        }
      }
    }
  }

  @HostListener('window:keyup.enter')
  changeByEnterkey() {
    if (this.foucsed) {
      var _ddl = this.tempContent as any[];
      var selectedDdl = _ddl[this.arrowkeyLocation];
      this.selectCommodityDDL(selectedDdl)
    }
  }
  @HostListener('window:keydown', ['$event'])
  onarrowDown(event) {
    if (this.foucsed) {
      if (event.key == 'ArrowDown') {
        if (this.arrowkeyLocation < this.tempContent.length - 1)
          return this.arrowkeyLocation++;
      }
      else {
        if (event.key == 'ArrowUp') {
          if (this.arrowkeyLocation > 0)
            return this.arrowkeyLocation--;
        }
      }
    }
  }
  foucsed = false
  triggerFoucs(onFoucs) {
    this.foucsed = onFoucs;
  }

  change() {
    this.isOpen = !this.isOpen;
    if (!this.isOpen) {
      // 14 means other (to specify commodity type)
      if (this.selectedValue.value != 14) {
        this.otherCommodity = false;
      }
      else {
        this.otherCommodity = true;
        this.notIsCommodity = true;
      }
    }
    else {
      // 14 means other (to specify commodity type)
      if (this.selectedValue.value == 14) {
        this.otherCommodity = true;
      }
      else {
        this.notIsCommodity = true;
        this.otherCommodity = false;
      }
    }
    this.isEnableSelectShipmentItems.emit(false);
  }

  search(e) {
    this.showCommodityList = true;
    this.tempContent = this.ddlContent;
    this.showDdl = true;
    this.searchTerm = e.target.value.toLowerCase();
    this.tempContent = this.tempContent.filter(item => {
      return item.key.toLowerCase().startsWith(e.target.value)
    })
  }
  ngOnInit() {
    this.tempContent = this.ddlContent;
    this.searchTerm = "";
  }
}
